<select-input (click)="onOpen()">
  <span>{{ selected }}</span>
  <i class="k-icon k-font-icon k-i-arrow-chevron-down"></i>
</select-input>
<select-options>
  <ul>
    <li
      *ngFor="let option of options; let i = index"
      (click)="onSelect($event.target)"
      [attr.data-value]="option.id"
    >
      {{ option.assignName }}
    </li>
  </ul>
</select-options>
